import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Cardio of krachttraining?</title>
                <link rel="canonical" href={route("blogs.fourth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Een eeuwige discussie die geen eenduidig antwoord heeft. Beide hebben namelijk hun voordelen en kunnen beide gebruikt worden om vet te verliezen."
                />
                <meta
                    property="og:description"
                    content="Een eeuwige discussie die geen eenduidig antwoord heeft. Beide hebben namelijk hun voordelen en kunnen beide gebruikt worden om vet te verliezen."
                />
                <meta property="og:url" content={route("blogs.fourth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Cardio of krachttraining? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/cardio-of-kracht.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/cardio-of-kracht.webp"
                                    type="image/webp"
                                    alt="Cardio of kracht"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/cardio-of-kracht.jpg"
                                    type="image/jpeg"
                                    alt="Cardio of kracht"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/cardio-of-kracht.jpg"
                                    alt="Cardio of kracht"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Cardio of krachttraining?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Een eeuwige discussie die geen eenduidig antwoord heeft.
                        Beide hebben namelijk hun voordelen en kunnen beide
                        gebruikt worden om vet te verliezen. Natuurlijk zitten
                        er wel verschillen tussen. Deze verschillen bepalen
                        welke keuze jij het beste kunt maken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Vetmassa verlagen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je vet wilt verliezen zul je ervoor moeten zorgen
                        dat je meer calorieën verbrand dan dat je binnenkrijgt.
                        Voeding bepaalt hoeveel calorieën je binnenkrijgt,
                        terwijl beweging in combinatie met je basale
                        energieverbruik bepaalt hoeveel calorieën je verbrand.
                        Je basale energieverbruik is de vetverbranding die in
                        volledige rust gebeurd.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Om vet te verliezen moet je er dus voor zorgen dat je
                        minder gaat eten en meer gaat bewegen. De vraag is bij
                        welke vorm je meer calorieën verbrand.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Krachttraining
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Mensen denken aan krachttraining weleens aan grote
                        spieren Dat is niet het lichaam wat ze willen creëren,
                        dus vermijden ze krachttraining. Doodzonde, want
                        krachttraining is juist een effectieve manier om een
                        mooi lichaam te krijgen. Als je krachttraining
                        combineert met een calorietekort zul je nauwelijks
                        spiermassa opbouwen, maar het gaat er wel voor zorgen
                        dat je je huidige spieren zoveel mogelijk zult behouden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is zo dat je in een uur intensieve cardiotraining
                        meer calorieën zult verbranden dan in een uur
                        krachttraining. Echter heb je bij krachttraining op de
                        langere termijn meer voordelen. Ten eerste is er het
                        afterburn effect. Dit zijn het aantal calorieën die je
                        verbrandt na het trainen. Tijdens krachttraining zullen
                        er minuscule spierscheurtjes ontstaan die je lichaam
                        moet gaan herstellen. Dit kost het lichaam energie,
                        waardoor je buiten het trainen om ook extra calorieën
                        zul verbranden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast hebben spieren meer energie nodig hebben om
                        behouden te blijven. Je basale energieverbruik zal
                        hierdoor toenemen, waardoor je meer zult verbranden
                        zonder iets te doen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het grote voordeel hiervan is dat je makkelijker op
                        gewicht kunt blijven. Je kunt met meer spiermassa dus
                        meer eten zonder daarbij aan te komen. Dat is zeer
                        belangrijk op de lange termijn. Zo word het makkelijker
                        om het gewicht niet alleen te verliezen, maar ook niet
                        meer terug aan te komen. Uiteindelijk is een blijvend
                        resultaat wat je wilt.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Cardiotraining
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Cardio is er in meerdere soorten. Elke sportschool heeft
                        wel een loopband, crosstrainer, hometrainer of
                        roeiapparaat. Hier maken ook veel mensen gebruik van.
                        Cardio is ook een goede manier om calorieën te
                        verbranden. Met name de intervaltraining is een zeer
                        effectieve manier om zoveel mogelijk calorieën te
                        verbranden. Hierbij wissel je zeer intensieve periodes
                        af met rustige periodes. Op een loopband kun je
                        bijvoorbeeld een stukje wandelen afwisselen met een
                        stukje sprinten.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Hiermee verbrand je in dezelfde tijd meer calorieën dan
                        bij duurtraining waarbij je constant op hetzelfde tempo
                        en intensiteit traint.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Klinkt allemaal heel positief. Je verbrand veel
                        calorieën dus je zal ook veel afvallen. Echter heeft
                        cardio zeker ook nadelen. Het grootste nadeel is de
                        afbraak van je spieren. Dit zal ervoor gaan zorgen dat
                        je wellicht niet het lichaam krijgt waar je naartoe wilt
                        werken. Je word heel erg dun en hebt nog maar heel
                        weinig rondingen en vormen over. Je moet je goed
                        afvragen af dat het lichaam is wat je wilt creëren.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast zal je van cardio een lage basale
                        energieverbruik krijgen. Dit betekent dat je continu
                        tegen de calorieën moet gaan vechten. Hier gaat het vaak
                        dan ook mis, omdat dit op de lange termijn heel lastig
                        is om vol te houden. Je hebt het gevoel dat je meteen
                        aankomt als je iets eet en daar zit dus ook een kern van
                        waarheid in. In veel gevallen krijg je hiermee een
                        jojo-effect. Dit werkt enorm demotiverend en zorgt niet
                        voor een blijvend resultaat.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat kan ik het beste doen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zo zie je dat zowel krachttraining als cardiotraining
                        voor- en nadelen hebben. De vraag rest wat voor jou het
                        beste werkt. Hiervoor zul je deze voor- en nadelen tegen
                        elkaar moeten afwegen. Welk lichaam wil jij creëren?
                        Deze vraag is ook belangrijk om hierin een keuze te
                        maken.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het leuke is dat het een het ander niet uitsluit. Je
                        kunt krachttraining en cardiotraining namelijk ook heel
                        goed combineren. Dit raden wij zelfs aan. Zo kun je aan
                        het einde van je krachttraining een vorm van cardio
                        doen. Idealiter gebruik je een vorm van intervaltraining
                        als cardio. Hiermee pak je de voordelen van zowel cardio
                        als krachttraining mee. Je verbrand extra calorieën door
                        de toevoeging van cardio en zult ook profijt hebben van
                        het afterburn effect en het verhogen van je basale
                        energieverbruik door de krachttraining. Dit geeft
                        uiteindelijk het beste en blijvend resultaat!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
